import styled from 'styled-components';

export const CheckMenuWrapper = styled.div`
  min-width: 370px;
`;

export const CheckOrderInfo = styled.div<{ $isPhysicianRoleGroup?: boolean }>`
  min-height: ${({ $isPhysicianRoleGroup }) =>
    $isPhysicianRoleGroup ? '0' : '150px'};
`;
